// Libs
import React from 'react'
import { NavLink } from 'react-router-dom'

// CSS
import './styles.scss'

const Pagination = ({ page, offset, total, perPage, leftActionIsVisible, loading, marginBottom, onSelect, ...props }) => {
  const allowFirst = offset > 0
  const allowPrevious = offset >= perPage
  const allowNext = offset < total - perPage
  const allowLast = offset < total - perPage
  let LeftAction = ''

  switch (page) {
    case 'meus-casos':
      LeftAction = 'Filtrar'
      break;
    case 'sp-case':
      LeftAction = 'Mais Informações'
      break;
    default:
  }

  return (
    <div style={{ marginBottom: `${marginBottom}px` }} className="pagination">
      <ul className="pagination__actions">
        {LeftAction &&
          <li
            className={!leftActionIsVisible ? 'pagination__action' : 'pagination__action pagination__action--disabled'}
            onClick={e => onSelect(LeftAction)}>
            {LeftAction}
          </li>
        }
        {page === 'meus-casos' &&
          <li>
            {`Exibindo ${total != 0 ? offset + 1 : 0}-${(offset + perPage) > total ? total : offset + perPage} de ${total}`}
          </li>
        }
        {page === 'dashboard' &&
          <li>
            {`Exibindo Últimos 30 Dias`}
          </li>
        }
      </ul>
      {page === 'meus-casos' && total > perPage &&
        <ul>
          <li
            className={allowFirst ? 'pagination__action' : 'pagination__action pagination__action--disabled'}
            onClick={e => allowFirst && onSelect('first')}>
            Primeira
          </li>
          <li
            className={allowPrevious ? 'pagination__action' : 'pagination__action pagination__action--disabled'}
            onClick={e => allowPrevious && onSelect('previous')}>
            Anterior
          </li>
          <li
            className={allowNext ? 'pagination__action' : 'pagination__action pagination__action--disabled'}
            onClick={e => allowNext && onSelect('next')}>
            Próxima
          </li>
          <li
            className={allowLast ? 'pagination__action' : 'pagination__action pagination__action--disabled'}
            onClick={e => allowLast && onSelect('last')}>
            Última
          </li>
        </ul>
      }
      {page === 'sp-case' &&
        <ul>
          <li className="pagination__action"><NavLink to="/meus-casos">Voltar a "Meus Casos"</NavLink></li>
        </ul>
      }
      {page === 'dashboard' &&
        <ul>
          <li
            className="pagination__action"
            onClick={e => allowLast && onSelect('last')}>
            Alterar Opções
          </li>
        </ul>
      }
    </div>
  )
}

export default Pagination
